<template>
    <b-row v-if="(row.status === '0')" :title="row.statusdescription">
        <div class="OTloading">
            <div class="ot-icon-ecm-mandatory-ok"></div>
         </div>
    </b-row>
    <b-row v-else-if="(row.status === '-1' || row.status === '1' || row.status === '2')"  :title="row.statusdescription">
        <div class="OTloading">
            <div class="ot-icon-ecm-mandatory"></div>
        </div>
    </b-row>
    <b-row v-else-if="(row.status === '3')" :title="row.statusdescription">
        <div class="OTloading">
            <div class="ot-icon-warning-ecm-status"></div>
        </div>
    </b-row>
    <b-row v-else-if="(row.status === '4')" :title="row.statusdescription">
        <div class="OTloading">
            <div class="ot-icon-ok-ecm-status"></div>
        </div>
    </b-row>
    <b-row v-else-if="(row.status === '5')" :title="row.statusdescription">
        <div class="OTloading">
            <div class="ot-icon-err-ecm-status"></div>
        </div>
    </b-row>
    <b-row v-else>
        <div class="OTloading">
           
        </div>
    </b-row>
</template>

<script>
export default {
    props: ['row'],
     created() {
        var that = this;
    }
}
</script>
